import {Link} from "react-router-dom";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {Pagination, Autoplay} from 'swiper/modules';
import Booking from "../Components/Booking/Booking";
import RecentBlog from "../Components/RecentBlog/RecentBlog";
import GetStarted from "../Components/GetStarted/GetStarted";

function Home() {
    return (
        <>
            <section className="mainBanner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="content">
                                <h3 data-aos='fade-right'>Welcome to Skill Bridge</h3>
                                <h1 data-aos='fade-right' data-aos-delay='50'>
                                    Your Gateway <br/> to DevOps <br/> Excellence
                                </h1>
                                <p data-aos='fade-right' data-aos-delay='100'>
                                    At Skill Bridge., we are not just a company; we are a revolution in the making. Our
                                    mission is clear - to bridge the gap between ambitious DevOps engineers and the
                                    ever-evolving technology landscape.
                                </p>
                                <div className="btnCont">
                                    <Link data-aos='fade-right' data-aos-delay='150' to="/about" className="themeBtn">Read
                                        More</Link>
                                    <Link data-aos='fade-right' data-aos-delay='200' to="/course-date"
                                          className="liveBtn">
                                        <i className="fas fa-play"/>
                                        <span>Live Sessions</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="imgCont" data-aos='fade-in' data-aos-delay='100'>
                                <figure>
                                    <img src={process.env.PUBLIC_URL + "/images/bannerImg.webp"} alt=""/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="clientSec">
                <div className='headline'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="imgCont">
                                    <img src={process.env.PUBLIC_URL + "/images/expert.webp"} alt=""/>
                                    <h5>Expert Instruction</h5>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="imgCont">
                                    <img src={process.env.PUBLIC_URL + "/images/remote.webp"} alt=""/>
                                    <h5>Remote Learning</h5>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="imgCont">
                                    <img src={process.env.PUBLIC_URL + "/images/quality.webp"} alt=""/>
                                    <h5>Quality Courses</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*<div className="container">*/}
                {/*    <div className="clientCont">*/}
                {/*        <div className="title center">*/}
                {/*            <h2 className="secHeading" data-aos='fade-up'>*/}
                {/*                Look what our clients have to say about us*/}
                {/*            </h2>*/}
                {/*            <p data-aos='fade-up' data-aos-delay='200'>*/}
                {/*                Trust is earned though working hard and going beyond the limits.*/}
                {/*            </p>*/}
                {/*            <div className="imgsCont">*/}
                {/*                <img src={process.env.PUBLIC_URL + "/images/c.webp"} alt=""/>*/}
                {/*                <img src={process.env.PUBLIC_URL + "/images/trustpilot.webp"} alt=""/>*/}
                {/*                <img src={process.env.PUBLIC_URL + "/images/google.webp"} alt=""/>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </section>

            <section className="programSec">
                <div className="container">
                    <div className="title">
                        <h4 className="subHeading" data-aos='fade-up'>
                            Explore Program
                        </h4>
                        <h2 className="secHeading" data-aos='fade-up' data-aos-delay='100'>Most Popular Courses</h2>
                        <p data-aos='fade-up' data-aos-delay='200'>
                            Let's join our famous class, the knowledge provided will definitely be useful you.
                        </p>
                    </div>
                    <Swiper
                        slidesPerView={1}
                        loop={true}
                        spaceBetween={10}
                        grabCursor={true}
                        // autoplay={{
                        //     delay: 3000,
                        //     disableOnInteraction: true,
                        // }}
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Pagination, Autoplay]}
                        className="programSlider"
                        breakpoints={{
                            767: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                            },
                            992: {
                                slidesPerView: 3,
                                spaceBetween: 10,
                            },
                            1200: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                            },
                            1366: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                        }}
                    >
                        <SwiperSlide>
                            <Link
                                className="courseCard"
                                to='/service-detail/1'
                                state={{
                                    img:"course1.webp",
                                    cat:"Web Development",
                                    uploader:{
                                        img:"user1.webp",
                                        name: "Jonathan Mask",
                                        pos: "FULL-STACK DEVELOPER"
                                    }
                                }}
                            >
                                <figure className='courseImg'>
                                    <img src={process.env.PUBLIC_URL + "/images/course1.webp"} alt=""/>
                                </figure>
                                <div className="content">
                                    <h5 className='category'>
                                        Web Development
                                    </h5>
                                    <h3 className="name">
                                        DevOps Engineering course
                                    </h3>
                                    <p className="details">
                                        The DevOps Engineering course offered by Skill Bridge is designed to empower
                                        aspiring DevOps professionals with the knowledge and skills needed to excel in
                                        this dynamic field.
                                    </p>
                                    <div className="minDetails">
                                        <div className="rating">
                                            <span>5.0</span>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                        </div>
                                        <div className="time">
                                            <i className="far fa-clock"/>
                                            <span>
                                                16 hr 30 mins
                                            </span>
                                        </div>
                                    </div>
                                    <div className="uploader">
                                        <div className="user">
                                            <figure>
                                                <img src={process.env.PUBLIC_URL + "/images/user1.webp"} alt=""/>
                                            </figure>
                                            <div className="userDetails">
                                                <h6>Jonathan Mask</h6>
                                                <p>FULL-STACK DEVELOPER</p>
                                            </div>
                                        </div>
                                        <div className="price">
                                            <h5>£120</h5>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link
                                className="courseCard"
                                to='/service-detail/2'
                                state={{
                                    img:"course2.webp",
                                    cat:"Design",
                                    uploader:{
                                        img:"user2.webp",
                                        name: "Austin",
                                        pos: "Designer"
                                    }
                                }}
                            >
                                <figure className='courseImg'>
                                    <img src={process.env.PUBLIC_URL + "/images/course2.webp"} alt=""/>
                                </figure>
                                <div className="content">
                                    <h5 className='category'>
                                        Design
                                    </h5>
                                    <h3 className="name">
                                        solution architect course
                                    </h3>
                                    <p className="details">
                                        Welcome to the Skill Bridge. SysOps Administrator Course! We are thrilled to
                                        have you embark on this educational journey with us, where you will gain the
                                        skills and knowledge necessary to excel in the dynamic and critical field of
                                        System OperaCons (SysOps).
                                    </p>
                                    <div className="minDetails">
                                        <div className="rating">
                                            <span>5.0</span>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                        </div>
                                        <div className="time">
                                            <i className="far fa-clock"/>
                                            <span>
                                                16 hr 30 mins
                                            </span>
                                        </div>
                                    </div>
                                    <div className="uploader">
                                        <div className="user">
                                            <figure>
                                                <img src={process.env.PUBLIC_URL + "/images/user2.webp"} alt=""/>
                                            </figure>
                                            <div className="userDetails">
                                                <h6>Austin</h6>
                                                <p>Designer</p>
                                            </div>
                                        </div>
                                        <div className="price">
                                            <h5>£120</h5>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link
                                className="courseCard"
                                to='/service-detail/3'
                                state={{
                                    img:"course3.webp",
                                    cat:"Design",
                                    uploader:{
                                        img:"user3.webp",
                                        name: "Hannah Baker",
                                        pos: "FULL-STACK DEVELOPER"
                                    }
                                }}
                            >
                                <figure className='courseImg'>
                                    <img src={process.env.PUBLIC_URL + "/images/course3.webp"} alt=""/>
                                </figure>
                                <div className="content">
                                    <h5 className='category'>
                                        Business Analytics
                                    </h5>
                                    <h3 className="name">
                                        SysOps Administrator Course
                                    </h3>
                                    <p className="details">
                                        Skill Bridge is pleased to introduce our Solution Architect Training program, a
                                        comprehensive course tailored to empower you with the skills and knowledge
                                        required to excel as a solution architect. In a rapidly evolving technology
                                        landscape, businesses need professionals who can bridge the gap between business
                                        goals and technical solutions, and that's exactly what this course is designed to
                                        help you achieve.
                                    </p>
                                    <div className="minDetails">
                                        <div className="rating">
                                            <span>5.0</span>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                        </div>
                                        <div className="time">
                                            <i className="far fa-clock"/>
                                            <span>
                                                16 hr 30 mins
                                            </span>
                                        </div>
                                    </div>
                                    <div className="uploader">
                                        <div className="user">
                                            <figure>
                                                <img src={process.env.PUBLIC_URL + "/images/user3.webp"} alt=""/>
                                            </figure>
                                            <div className="userDetails">
                                                <h6>Jonathan Mask</h6>
                                                <p>FULL-STACK DEVELOPER</p>
                                            </div>
                                        </div>
                                        <div className="price">
                                            <h5>£120</h5>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link className="courseCard" to='/service-detail/1'>
                                <figure className='courseImg'>
                                    <img src={process.env.PUBLIC_URL + "/images/course1.webp"} alt=""/>
                                </figure>
                                <div className="content">
                                    <h5 className='category'>
                                        Web Development
                                    </h5>
                                    <h3 className="name">
                                        DevOps Engineering course
                                    </h3>
                                    <p className="details">
                                        The DevOps Engineering course offered by Skill Bridge is designed to empower
                                        aspiring DevOps professionals with the knowledge and skills needed to excel in
                                        this dynamic field.
                                    </p>
                                    <div className="minDetails">
                                        <div className="rating">
                                            <span>5.0</span>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                        </div>
                                        <div className="time">
                                            <i className="far fa-clock"/>
                                            <span>
                                                16 hr 30 mins
                                            </span>
                                        </div>
                                    </div>
                                    <div className="uploader">
                                        <div className="user">
                                            <figure>
                                                <img src={process.env.PUBLIC_URL + "/images/user1.webp"} alt=""/>
                                            </figure>
                                            <div className="userDetails">
                                                <h6>Jonathan Mask</h6>
                                                <p>FULL-STACK DEVELOPER</p>
                                            </div>
                                        </div>
                                        <div className="price">
                                            <h5>£120</h5>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link className="courseCard" to='/service-detail/2'>
                                <figure className='courseImg'>
                                    <img src={process.env.PUBLIC_URL + "/images/course2.webp"} alt=""/>
                                </figure>
                                <div className="content">
                                    <h5 className='category'>
                                        Design
                                    </h5>
                                    <h3 className="name">
                                        solution architect course
                                    </h3>
                                    <p className="details">
                                        Welcome to the Skill Bridge. SysOps Administrator Course! We are thrilled to
                                        have you embark on this educational journey with us, where you will gain the
                                        skills and knowledge necessary to excel in the dynamic and critical field of
                                        System OperaCons (SysOps).
                                    </p>
                                    <div className="minDetails">
                                        <div className="rating">
                                            <span>5.0</span>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                        </div>
                                        <div className="time">
                                            <i className="far fa-clock"/>
                                            <span>
                                                16 hr 30 mins
                                            </span>
                                        </div>
                                    </div>
                                    <div className="uploader">
                                        <div className="user">
                                            <figure>
                                                <img src={process.env.PUBLIC_URL + "/images/user2.webp"} alt=""/>
                                            </figure>
                                            <div className="userDetails">
                                                <h6>Austin</h6>
                                                <p>Designer</p>
                                            </div>
                                        </div>
                                        <div className="price">
                                            <h5>£120</h5>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link className="courseCard" to='/service-detail/3'>
                                <figure className='courseImg'>
                                    <img src={process.env.PUBLIC_URL + "/images/course3.webp"} alt=""/>
                                </figure>
                                <div className="content">
                                    <h5 className='category'>
                                        Business Analytics
                                    </h5>
                                    <h3 className="name">
                                        SysOps Administrator Course
                                    </h3>
                                    <p className="details">
                                        Skill Bridge is pleased to introduce our Solution Architect Training program, a
                                        comprehensive course tailored to empower you with the skills and knowledge
                                        required to excel as a solution architect. In a rapidly evolving technology
                                        landscape, businesses need professionals who can bridge the gap between business
                                        goals and technical solutions, and that's exactly what this course is designed to
                                        help you achieve.
                                    </p>
                                    <div className="minDetails">
                                        <div className="rating">
                                            <span>5.0</span>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                            <i className="fas fa-star"/>
                                        </div>
                                        <div className="time">
                                            <i className="far fa-clock"/>
                                            <span>
                                                16 hr 30 mins
                                            </span>
                                        </div>
                                    </div>
                                    <div className="uploader">
                                        <div className="user">
                                            <figure>
                                                <img src={process.env.PUBLIC_URL + "/images/user3.webp"} alt=""/>
                                            </figure>
                                            <div className="userDetails">
                                                <h6>Jonathan Mask</h6>
                                                <p>FULL-STACK DEVELOPER</p>
                                            </div>
                                        </div>
                                        <div className="price">
                                            <h5>£120</h5>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </section>

            <section className="serviceSec">
                <div className="container">
                    <div className="title center">
                        <h3 className="subHeading" data-aos='fade-up'>
                            Our Service
                        </h3>
                        <h2 className="secHeading" data-aos='fade-up' data-aos-delay='100'>
                            Fostering A Playful And Engaging <br/> Learning Environment
                        </h2>
                    </div>
                    <Swiper
                        slidesPerView={1}
                        loop={true}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: true,
                        }}
                        spaceBetween={0}
                        grabCursor={true}
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Pagination, Autoplay]}
                        className="programSlider"
                        breakpoints={{
                            767: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                            },
                            992: {
                                slidesPerView: 3,
                                spaceBetween: 10,
                            },
                            1199: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                            },
                            1366: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                        }}
                    >
                        <SwiperSlide>
                            <div className="serviceCard">
                                <div className="serviceTitle">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + '/images/service1.webp'} alt=""/>
                                    </figure>
                                    <h4>Upskilling & Professional Development</h4>
                                </div>
                                <div className="content">
                                    <p>
                                        Welcome to Skill Bridge, your trusted partner in the pursuit of knowledge,
                                        growth, and professional excellence. We are dedicated to empowering individuals
                                        like you with the tools, resources, and guidance needed to upskill and excel in
                                        your chosen field.
                                    </p>
                                    <Link to="" className="learnBtn"><span>Learn More</span> <i
                                        className="far fa-chevron-right"/></Link>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="serviceCard orange">
                                <div className="serviceTitle">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + '/images/service2.webp'} alt=""/>
                                    </figure>
                                    <h4>Flexible Learning Format</h4>
                                </div>
                                <div className="content">
                                    <p>
                                        Welcome to Skill Bridge, where we understand that education is not a
                                        one-size-fits-all endeavour. Our Flexible Learning Formats service is designed
                                        to meet you where you are and provide the educational experience you desire,
                                        regardless of your schedule, location, or personal preferences.
                                    </p>
                                    <Link to="" className="learnBtn"><span>Learn More</span> <i
                                        className="far fa-chevron-right"/></Link>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="serviceCard pink">
                                <div className="serviceTitle">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + '/images/service3.webp'} alt=""/>
                                    </figure>
                                    <h4>Certifications and Credentials</h4>
                                </div>
                                <div className="content">
                                    <p>
                                        Whether you're learning online or in person, you'll have access to the same
                                        high-quality education and the opportunity to earn industry-recognized
                                        certifications.
                                    </p>
                                    <Link to="" className="learnBtn"><span>Learn More</span> <i
                                        className="far fa-chevron-right"/></Link>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="serviceCard">
                                <div className="serviceTitle">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + '/images/service1.webp'} alt=""/>
                                    </figure>
                                    <h4>Workforce Training & Upskilling</h4>
                                </div>
                                <div className="content">
                                    <p>
                                        At Skill Bridge, we provide tailored training solutions to empower your current
                                        workforce with the latest DevOps methodologies, tools, and industry best
                                        practices. Our customized training programs are designed to align seamlessly with
                                        your organization's unique needs and objectives.
                                    </p>
                                    <Link to="" className="learnBtn"><span>Learn More</span> <i
                                        className="far fa-chevron-right"/></Link>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="serviceCard">
                                <div className="serviceTitle">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + '/images/service1.webp'} alt=""/>
                                    </figure>
                                    <h4>Upskilling & Professional Development</h4>
                                </div>
                                <div className="content">
                                    <p>
                                        Welcome to Skill Bridge, your trusted partner in the pursuit of knowledge,
                                        growth, and professional excellence. We are dedicated to empowering individuals
                                        like you with the tools, resources, and guidance needed to upskill and excel in
                                        your chosen field.
                                    </p>
                                    <Link to="" className="learnBtn"><span>Learn More</span> <i
                                        className="far fa-chevron-right"/></Link>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="serviceCard orange">
                                <div className="serviceTitle">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + '/images/service2.webp'} alt=""/>
                                    </figure>
                                    <h4>Flexible Learning Format</h4>
                                </div>
                                <div className="content">
                                    <p>
                                        Welcome to Skill Bridge, where we understand that education is not a
                                        one-size-fits-all endeavour. Our Flexible Learning Formats service is designed
                                        to meet you where you are and provide the educational experience you desire,
                                        regardless of your schedule, location, or personal preferences.
                                    </p>
                                    <Link to="" className="learnBtn"><span>Learn More</span> <i
                                        className="far fa-chevron-right"/></Link>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="serviceCard pink">
                                <div className="serviceTitle">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + '/images/service3.webp'} alt=""/>
                                    </figure>
                                    <h4>Certifications and Credentials</h4>
                                </div>
                                <div className="content">
                                    <p>
                                        Whether you're learning online or in person, you'll have access to the same
                                        high-quality education and the opportunity to earn industry-recognized
                                        certifications.
                                    </p>
                                    <Link to="" className="learnBtn"><span>Learn More</span> <i
                                        className="far fa-chevron-right"/></Link>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="serviceCard">
                                <div className="serviceTitle">
                                    <figure>
                                        <img src={process.env.PUBLIC_URL + '/images/service1.webp'} alt=""/>
                                    </figure>
                                    <h4>Workforce Training & Upskilling</h4>
                                </div>
                                <div className="content">
                                    <p>
                                        At Skill Bridge, we provide tailored training solutions to empower your current
                                        workforce with the latest DevOps methodologies, tools, and industry best
                                        practices. Our customized training programs are designed to align seamlessly with
                                        your organization's unique needs and objectives.
                                    </p>
                                    <Link to="" className="learnBtn"><span>Learn More</span> <i
                                        className="far fa-chevron-right"/></Link>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </section>

            <GetStarted
                mainImg="benefitImg.webp"
                heading="Benefits of online Learning Services at E-Learning"
                description={[
                    'Online learning services at Skill Bridge offer numerous benefits to learners, making it a flexible and accessible opMon for skill development.'
                ]}
                listing={[
                    {
                        'img': 'benIcon1.webp',
                        'title': 'Global Access',
                        'content': 'Online learning eliminates geographical barriers, enabling learners from around the world to access high-quality educational content and interact with instructors and peers regardless of their location.'
                    },
                    {
                        'img': 'benIcon2.webp',
                        'title': 'Mentor Based Learning',
                        'content': 'Courses are typically taught by experienced professionals and subject maGer experts, ensuring that learners receive top-quality instruction.'
                    },
                    {
                        'img': 'benIcon3.webp',
                        'title': 'Diverse Course Catalogue',
                        'content': 'Skill Bridge offers a wide range of courses across various disciplines, providing you with the opportunity to explore new fields or deepen your expertise in your current area of interest.'
                    },
                    {
                        'img': 'benIcon3.webp',
                        'title': 'Life-Long Learning',
                        'content': 'Skill Bridge promotes the idea that learning is a lifelong journey. Our online learning services make it possible to engage in education at any stage of your career, whether you\'re a student, a professional, or someone simply eager to broaden your knowledge.'
                    },
                ]}
            />

            {/*<section className="testimonialSec">*/}
            {/*    <div className="container">*/}
            {/*        <div className="row">*/}
            {/*            <div className="col-12">*/}
            {/*                <div className="title center">*/}
            {/*                    <h3 className="subHeading" data-aos='fade-up'>*/}
            {/*                        What they say*/}
            {/*                    </h3>*/}
            {/*                    <h2 className="secHeading" data-aos='fade-up' data-aos-delay='100'>*/}
            {/*                        What Our Students Say*/}
            {/*                    </h2>*/}
            {/*                    <p data-aos='fade-up' data-aos-delay='200'>*/}
            {/*                        Velit Officia consequat duis enim velit mollit. Exercitation veniam consequat sunt*/}
            {/*                        nostrud*/}
            {/*                        amet.*/}
            {/*                    </p>*/}
            {/*                </div>*/}
            {/*                <Swiper*/}
            {/*                    slidesPerView={1}*/}
            {/*                    spaceBetween={10}*/}
            {/*                    autoplay={{*/}
            {/*                        delay: 3000,*/}
            {/*                        disableOnInteraction: true,*/}
            {/*                    }}*/}
            {/*                    grabCursor={true}*/}
            {/*                    navigation={true}*/}
            {/*                    modules={[Navigation, Autoplay]}*/}
            {/*                    className="testimonialSlider"*/}
            {/*                    breakpoints={{*/}
            {/*                        992: {*/}
            {/*                            slidesPerView: 2,*/}
            {/*                        }*/}
            {/*                    }}*/}
            {/*                >*/}
            {/*                    <SwiperSlide>*/}
            {/*                        <div className="testimonialCard">*/}
            {/*                            <div className="user">*/}
            {/*                                <figure>*/}
            {/*                                    <img src={process.env.PUBLIC_URL + "/images/testiUser1.webp"} alt=""/>*/}
            {/*                                </figure>*/}
            {/*                                <h4>John De Marli</h4>*/}
            {/*                                <span>President of Sales</span>*/}
            {/*                                <div className="rating">*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                </div>*/}
            {/*                                <div className="content">*/}
            {/*                                    <p>*/}
            {/*                                        any individuals have eaten in this kitchen and have proceeded to*/}
            {/*                                        lead*/}
            {/*                                        typical. solid*/}
            {/*                                        lives. The route to a man”s heart is through his stomach*/}
            {/*                                    </p>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </SwiperSlide>*/}
            {/*                    <SwiperSlide>*/}
            {/*                        <div className="testimonialCard">*/}
            {/*                            <div className="user">*/}
            {/*                                <figure>*/}
            {/*                                    <img src={process.env.PUBLIC_URL + "/images/testiUser1.webp"} alt=""/>*/}
            {/*                                </figure>*/}
            {/*                                <h4>John De Marli</h4>*/}
            {/*                                <span>President of Sales</span>*/}
            {/*                                <div className="rating">*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                </div>*/}
            {/*                                <div className="content">*/}
            {/*                                    <p>*/}
            {/*                                        any individuals have eaten in this kitchen and have proceeded to*/}
            {/*                                        lead*/}
            {/*                                        typical. solid*/}
            {/*                                        lives. The route to a man”s heart is through his stomach*/}
            {/*                                    </p>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </SwiperSlide>*/}
            {/*                    <SwiperSlide>*/}
            {/*                        <div className="testimonialCard">*/}
            {/*                            <div className="user">*/}
            {/*                                <figure>*/}
            {/*                                    <img src={process.env.PUBLIC_URL + "/images/testiUser1.webp"} alt=""/>*/}
            {/*                                </figure>*/}
            {/*                                <h4>John De Marli</h4>*/}
            {/*                                <span>President of Sales</span>*/}
            {/*                                <div className="rating">*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                            <div className="content">*/}
            {/*                                <p>*/}
            {/*                                    any individuals have eaten in this kitchen and have proceeded to lead*/}
            {/*                                    typical. solid*/}
            {/*                                    lives. The route to a man”s heart is through his stomach*/}
            {/*                                </p>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </SwiperSlide>*/}
            {/*                    <SwiperSlide>*/}
            {/*                        <div className="testimonialCard">*/}
            {/*                            <div className="user">*/}
            {/*                                <figure>*/}
            {/*                                    <img src={process.env.PUBLIC_URL + "/images/testiUser1.webp"} alt=""/>*/}
            {/*                                </figure>*/}
            {/*                                <h4>John De Marli</h4>*/}
            {/*                                <span>President of Sales</span>*/}
            {/*                                <div className="rating">*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                </div>*/}
            {/*                                <div className="content">*/}
            {/*                                    <p>*/}
            {/*                                        any individuals have eaten in this kitchen and have proceeded to*/}
            {/*                                        lead*/}
            {/*                                        typical. solid*/}
            {/*                                        lives. The route to a man”s heart is through his stomach*/}
            {/*                                    </p>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </SwiperSlide>*/}
            {/*                    <SwiperSlide>*/}
            {/*                        <div className="testimonialCard">*/}
            {/*                            <div className="user">*/}
            {/*                                <figure>*/}
            {/*                                    <img src={process.env.PUBLIC_URL + "/images/testiUser1.webp"} alt=""/>*/}
            {/*                                </figure>*/}
            {/*                                <h4>John De Marli</h4>*/}
            {/*                                <span>President of Sales</span>*/}
            {/*                                <div className="rating">*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                </div>*/}
            {/*                                <div className="content">*/}
            {/*                                    <p>*/}
            {/*                                        any individuals have eaten in this kitchen and have proceeded to*/}
            {/*                                        lead*/}
            {/*                                        typical. solid*/}
            {/*                                        lives. The route to a man”s heart is through his stomach*/}
            {/*                                    </p>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </SwiperSlide>*/}
            {/*                    <SwiperSlide>*/}
            {/*                        <div className="testimonialCard">*/}
            {/*                            <div className="user">*/}
            {/*                                <figure>*/}
            {/*                                    <img src={process.env.PUBLIC_URL + "/images/testiUser1.webp"} alt=""/>*/}
            {/*                                </figure>*/}
            {/*                                <h4>John De Marli</h4>*/}
            {/*                                <span>President of Sales</span>*/}
            {/*                                <div className="rating">*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                    <i className="fas fa-star"/>*/}
            {/*                                </div>*/}
            {/*                                <div className="content">*/}
            {/*                                    <p>*/}
            {/*                                        any individuals have eaten in this kitchen and have proceeded to*/}
            {/*                                        lead*/}
            {/*                                        typical. solid*/}
            {/*                                        lives. The route to a man”s heart is through his stomach*/}
            {/*                                    </p>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </SwiperSlide>*/}
            {/*                </Swiper>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</section>*/}

            <Booking/>

            <RecentBlog/>
        </>
    )
}

export default Home